import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationHostTypeService } from 'rome-library';
import { Observable, Subject } from 'rxjs';
import { States } from '../../shared/constants/states';
import { CaseNavigationViewModel } from '../models/case-navigation-viewmodel.model';

@Injectable({
  providedIn: 'root'
})
export class CaseNavigationService {
  private readonly navigateToCaseSubject = new Subject<CaseNavigationViewModel>();

  constructor(
    private readonly router: Router,
    private readonly applicationHostTypeService: ApplicationHostTypeService
  ) {}

  public goToCase(navigation: CaseNavigationViewModel): void {
    if (this.navigateToCaseSubject.observers.length === 0) {
      void this.router.navigate(['/', this.applicationHostTypeService.getCode(), States.CustomerHub]);
    }
    this.navigateToCaseSubject.next(navigation);
  }

  public completeNavigation(): void {
    this.navigateToCaseSubject.next(undefined);
  }

  public caseNavigationAsObservable(): Observable<CaseNavigationViewModel> {
    return this.navigateToCaseSubject.asObservable();
  }
}
